module.exports = __webpack_public_path__ + "static/media/trust.6c810359.svg";